import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { motion } from 'framer-motion';
import AttractorTimeout from '../../warning/attractorTimeout';

const container = {
    hidden: { opacity: 0, },
    show: {
        opacity: 1,

        transition: {
            delayChildren: 0.5,
        }
    }
};
const item = {
    hidden: { opacity: 0, y: -25, },
    show: i =>  ({
        opacity: 1,
        y: 0,

        transition: {
            duration: .2,
            delay: i * 0.2 + 0.1,
            ease: "easeInOut",
        },
    }),
};

const LeaderboardScore = ({ config, IsEndGameScore, scores, currentScore, gameData, passRefUpward }) => {

    AttractorTimeout(config, passRefUpward);

    const leaderboardClass = classNames('leaderboard-score', { 'leaderboard-score__isEndGameScore': IsEndGameScore });

    if (!scores) {
        scores = JSON.parse(window.sessionStorage.getItem('storedScores')) || [];
    }
    let scoresToShow = scores;
    scoresToShow.sort((a, b) => b.date - a.date).sort((a, b) => b.score - a.score);
    const placeholderItems = [];
    for (let count = 10 - scoresToShow.length; count > 0; count -= 1) {
        placeholderItems.push(<motion.li variants={item} custom={10 - count} key={`placeholder_${count}`} className='leaderboard__results-result full'> <span className='dotted'> </span> </motion.li>);
    }

    let mappedScores = [];

    if (scoresToShow.length > 0) {
        mappedScores = scoresToShow.map((result, idx) => {
            if (idx > 9) return false;
            if (result.score === null || result.score < 0) return <motion.li custom={idx} variants={item} key={`placeholder_score_${idx}`} className='leaderboard__results-result full'> <span className='dotted'> </span> </motion.li>;

            const leaderboardResult = classNames(
                'leaderboard__results-result',
                { 'current': result.date === currentScore?.date }
            );
            let placement;
            switch(idx) {
                case 0:
                    placement = '1st';
                    break;
                case 1:
                    placement = '2nd';
                    break;
                case 2:
                    placement = '3rd';
                    break;
                default:
                    placement = (idx + 1) + 'th';
            }
            return (
                <motion.li custom={idx} variants={item} className={leaderboardResult} key={result.date}>
                    <div className='placement'>
                        <span>{placement}</span>
                    </div>
                    <span className='score' >{result.score.toLocaleString()}</span>
                    {result.level &&
                        <span className='level'>
                            <span>Level {result.level}</span>
                        </span>
                    }
                </motion.li>
            );
        })
    }

    return (
        <div className={leaderboardClass}>
            {/* <div className='leaderboard-score__internal'>
                {!IsEndGameScore && (
                    <div className='leaderboard-score__game App__game'>
                        <img src={`/img/game_icons/${gameData.screens.leaderboardScreen.icon}.svg`} alt='' />
                        <p>{config.screens.landingScreen.vertical_title || config.gameName }</p>
                    </div>
                )}

                <h1>{config.screens.leaderboardScreen.title}</h1>
                <motion.ul variants={container} initial="hidden" animate="show" className='leaderboard-score__results'>
                    {mappedScores}
                    {placeholderItems}
                </motion.ul>

                {!IsEndGameScore && (
                    <button>
                        <Link to='/'>{config.screens.leaderboardScreen.button_text}</Link>
                    </button>
                )}
            </div> */}
        </div>
    );
};

LeaderboardScore.propTypes = {
    IsEndGameScore: PropTypes.bool,
};

LeaderboardScore.defaultProps = {
    IsEndGameScore: false,
};

export default LeaderboardScore;
